<script>
import RadioButton from 'primevue/radiobutton';

export default {
  components: {RadioButton},
  inject: {pSubmitted: {default: null}, pDisabled: {default: null}},
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    modelValue: {
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
    className: {
      type: String,
      required: false,
      default: '',
    },
    binary: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    labelClass: {
      type: String,
      required: false,
      default: 'font-semibold text-grey-900 text-base',
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      id: null,
    };
  },
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
    getPlaceholder() {
      return this.placeholder ? this.placeholder : this.label;
    },
    isDisabled() {
      if (this.disabled !== undefined) return this.disabled;
      if (this.pDisabled !== undefined) return this.pDisabled;
      return false;
    },
  },
  mounted() {
    this.id = 'id_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  },
  methods: {},
};
</script>

<template>
  <div :class="className" class="form-group">
    <div class="flex items-center gap-2">
      <RadioButton
        :inputId="id"
        v-model="currentValue"
        :binary="binary"
        :value="value"
        :disabled="disabled"
        class="form-check-input" />
      <label class="flex-1 font-inter hover:cursor-pointer" :class="labelClass" :for="id"> {{ this.label }}</label>
    </div>
  </div>
</template>
